export interface IMailInfo {
    accessToken: string;
    itemId: string;
    targetInbox?: string | null;
}
export interface ISaveInfo {
    documentArchive: string;
    documentCategory: string;
    caseReno: string | null;
    documentTitle: string;
    ccContact?: IContactInfo[] | null;
    recordType?: string | null;
    accessProps?: IAccessProperties;
    documentDate?: IDateOnly;
    publicTitle?: string;
}

export interface ISaveMailInfo extends IMailInfo, ISaveInfo {
}

export interface IContactInfo {
    Recno: number;
    Name: string;
    IsInternal: boolean;
    Domain: number;
    EmployerRecno: number;
    EmployerName: string;
    Address: string;
    Zip: string;
}

export interface IAccessProps {
    AccessCode: number;
    AccessGroup: number;
    Paragraph: string | null;
}
export interface IAccessProperties extends IAccessProps {
    AccessCode: number;
    AccessGroup: number;
    Paragraph: string | null;
    ArchiveHasAccessCode?: number;
    ArchiveHasAccessGroup?: number;
    IsRestricted?: boolean;
}
export const unrestrictedAccess: IAccessProperties = {
    AccessCode: 0, // Unclassified
    AccessGroup: 0, // public
    Paragraph: null
};
export default interface IDateOnly {
    /** The day of the month; as a number from 1-31 */
    Day: number;

    /** The month of the specified date; as a number from 1-12 (January is 1) */
    Month: number;

    /** The year of the specified date; as a four digit number */
    Year: number;
}

export const DateOnly = {
    FromDate: (date: Date | IDateOnly): IDateOnly => {
        if (DateOnly.IsInstanceOfDateOnly(date))
            return date;
        return {
            Day: date.getDate(),
            Month: date.getMonth() + 1,
            Year: date.getFullYear()
        };
    },
    ToDate: (dateOnly: IDateOnly): Date => {
        return new Date(dateOnly.Year, dateOnly.Month - 1, dateOnly.Day);
    },
    IsInstanceOfDateOnly: (object: unknown): object is IDateOnly => {
        if (typeof object !== 'object') return false;
        return object ? 'Day' in object && 'Month' in object && 'Year' in object : false;
    },
    AreEqual: (date1: IDateOnly, date2: IDateOnly): boolean => {
        return date1.Day === date2.Day && date1.Month === date2.Month && date1.Year === date2.Year;
    },
    Today: (): IDateOnly => {
        return DateOnly.FromDate(new Date());
    }
};